module.exports = __webpack_public_path__ + "static/media/nexo.7309ac8b.svg";